import { render, staticRenderFns } from "./side-panel-body.vue?vue&type=template&id=a6d16fd4"
import script from "./side-panel-body.vue?vue&type=script&lang=js"
export * from "./side-panel-body.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports